import { Wording } from '@/types';

export const LOVE_WORDING_NO: Wording = {
  components_header_media_content: 'Lydfiler',
  components_header_media_1: 'Meditasjoner',
  components_header_media_2: 'Podkast',
  components_header_text1: 'Guider',
  components_header_text2: 'Blogg',
  components_header_members: 'Medlemmer',
  hero_text: 'Oppdag kjærligheten gjennom stjernene',
  hero_button_text: 'Begynn reisen din',
  components_ressources_section_title: 'KJÆRLIGHET OG ASTROLOGI',
  components_ressources_subheader_text: 'Ditt himmelske verktøysett for romantisk innsikt',
  components_ressources_span_text: 'Dykk ned i vårt univers av podkaster og artikler sentrert rundt kjærlighet, stjernetegnskompatibilitet og kosmisk tilknytning. Enten du søker etter sjelevenn-klarhet eller avkoder dine forholdsmønstre, veileder ressursene våre deg til dypere forståelse gjennom stjernene.',
  components_ressources_card_1_title: 'Stjernetegn kjærlighetssamtaler',
  components_ressources_card_1_text: 'Utforsk hjertevarme podkastepisoder som fordyper seg i det emosjonelle språket til hvert stjernetegn, kjærlighetskompatibilitet, lidenskap og personlig vekst i forhold.',
  components_ressources_card_2_title: 'Kjærlighetsblogg',
  components_ressources_card_2_text: 'Les innsikter og refleksjoner om hvordan hvert stjernetegn elsker, helbreder og forbinder. Fra synastri til planetarisk romantikk, bloggen vår er din guide til astrologisk kjærlighet.',
  components_ressources_link: 'Utforsk videre',
  components_notes_and_google_title_1: 'Romantisk astrologi',
  components_notes_and_google_title_2: 'Kjærlighetsvaner',
  components_notes_and_google_title_3: 'Lytternes kjærlighetsrefleksjoner',
  components_review_google_text: 'Hva lytterne våre sier',
  media_content_section_title: 'KJÆRLIGHET & STJERNEBÅNDSPODKASTEN',
  media_content_section_subheader_text: 'Ærlig snakk om kosmisk romantikk',
  text_media_1: 'Følg med på dyptgående, avslørende episoder om astrologiske treff, emosjonelle mønstre og romantisk dynamikk.',
  text_media_2: '',
  media_content_section_button_more: 'Lytt nå',
  text2_section_title: 'BLOGG',
  text2_section_subheader_text: 'Astrologiske kjærlighetshistorier og innsikter',
  text2_section_button_more: 'Last inn mer',
  components_text1_section_title: 'GUIDER',
  components_text1_subheader_text: '',
  components_text1_span_text: '',
  components_text1_card_1_title: '',
  components_text1_card_1_text: '',
  components_text1_card_3_title: '',
  components_text1_card_3_text: '',
  components_text1_card_2_title: '',
  components_text1_card_2_text: '',
  components_text1_link: '',
  components_footer_text: 'La stjernene veilede kjærlighetshistorien din',
  components_footer_info: 'Info',
  components_footer_registration_number: 'Registreringsnummer',
  components_footer_legal: 'Juridisk',
  components_footer_terms: 'Vilkår og betingelser',
  components_footer_privacy: 'Personvernerklæring',
  button_load_more: 'Last inn mer',
  page_media_2_content_hero_text: '',
  page_media_content_menu_antistress: '',
  page_media_content_menu_mindfulness: '',
  page_media_content_menu_energyboost: '',
  page_media_content_menu_mantra: '',
  page_media_1_content_hero_text: 'Kjærlighet og stjernetegn: Podcast-episoder',
  page_media_content_menu_compatibility: 'Kompatibilitet',
  page_media_content_menu_love: 'Kjærlighet',
  page_text1_hero_text: '',
  page_text1_section_title: '',
  page_text1_subheader_text: '',
  page_text2_hero_text: 'Utforsk kjærlighet gjennom astrologi',
  page_text2_section_title: 'Blogg',
  page_text2_subheader_text: 'Artikler',
  enter_email_title: 'Vennligst skriv inn e-postadressen din for å fortsette',
  enter_email_placeholder_email: 'E-post',
  enter_email_button_enter: 'Gå',
  components_login_success_text: 'Innlogging vellykket!',
  components_card_link_media_content: 'Lytt nå',
  components_card_link_text2_content: 'Les artikler',
  components_card_link_text1_content: '',
  tag_podcast: 'Podkast',
  tag_meditation: 'Meditasjon',
  page_media_content_menu_all: 'Alle',
};